import React, { Suspense as ReactSuspense } from 'react';
import styles from './Suspense.module.less';

type SuspenseWrapProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export const fallbackRender = () => {
  return (
    <div className={styles.loaderScreenContainer}>
      <div className={styles.loader}></div>
    </div>
  );
};

export const Suspense = ({ children, fallback = fallbackRender() }: SuspenseWrapProps) => {
  return (
    <div>
      <ReactSuspense fallback={fallback}>{children}</ReactSuspense>
    </div>
  );
};
